import { useCallback, useState } from "react";
import Loader from "../../shared/Loader";
import ExcelPopupBtn from "./PopupBtns/ExcelPopupBtn";
import FilterDetailBar from "./PopupBtns/FilterDetailBar";
import AdvanceSearchBtn from "./PopupBtns/AdvanceSearchBtn";
import { useGetIncomes } from "../../lib/queries/queriesAndMutations";
import Pagination from "../../shared/Pagination";
import { withdrawFieldLabels, withdrawsFields } from "../../lib/constants";
import { useDebounce } from "../../hooks/useDebounce";
import IncomeCard from "../../shared/IncomeCard";
import InformationTooltip from "../../ui/InformationTooltip";

const IncomesList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useState({
    user_id: "",
  });
  const pageSize = 20;

  // Debounce the search params to avoid rapid API calls
  const debouncedSearchParams = useDebounce(searchParams, 1024);

  const onPageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const {
    data: incomesList,
    isPending,
    isRefetching,
  } = useGetIncomes({
    debouncedQueryParams: debouncedSearchParams,
    currentPage,
  });

  // Loading State
  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex justify-center items-center min-h-[400px]">
        <Loader />
      </div>
    );
  }

  const hasResults = incomesList?.count > 0;

  return (
    <>
      <div className="figure-wrapper space-y-2">
        <div className="flex w-full gap-[10px] ">
          <InformationTooltip />
          <ExcelPopupBtn
            searchTermRef={searchParams}
            fields={withdrawsFields}
            url="incomes"
          />
          <AdvanceSearchBtn setSearchTerm={setSearchParams} />
        </div>
        <FilterDetailBar
          searchTerm={searchParams}
          setSearchTerm={setSearchParams}
          labelFields={withdrawFieldLabels}
        />
      </div>
      <div className="figure-wrapper">
        {/* Results */}
        {hasResults ? (
          <div className="space-y-4 w-full">
            <div className="flex flex-col gap-2 w-full">
              {incomesList?.results.map((item, index) => (
                <IncomeCard key={item.id} item={item} index={index} />
              ))}
            </div>
            {/* Pagination */}
            <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
              <Pagination
                onPageChange={onPageChange}
                totalCount={incomesList?.count || 0}
                siblingCount={1}
                currentPage={currentPage}
                pageSize={pageSize}
                className="bg-neutral-10"
              />
            </div>
          </div>
        ) : (
          <EmptyState />
        )}
      </div>
    </>
  );
};

/** Extract Empty State UI for clarity */
const EmptyState = () => (
  <div className="flex flex-col items-center p-6 rounded-md">
    <img
      src="/images/businessbriefcase.svg"
      alt="No Incomes Found"
      className="max-w-[40px] max-h-[40px] invert rounded-md p-2"
    />
    <p>درآمدی یافت نشد!</p>
  </div>
);

export default IncomesList;
